import { useState, useCallback, memo, HTMLAttributes, MouseEvent, forwardRef } from 'react';
import cn from 'classnames';

import BackgroundImage from '@UI/BackgroundImage';
import Popup from '@UI/Popup';
import Cross from '@UI/Cross';
import { Parameter } from '@Pages/PageProduct';
import styles from './MechanismPopup.module.css';

export interface MechanismPopupProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  visible?: boolean;
  parameter?: Parameter;
  onClose?: (e: MouseEvent) => void;
}

const MechanismPopup = forwardRef<HTMLDivElement, MechanismPopupProps>((props, ref) => {
  const { visible, parameter, className, onClose, ...restProps } = props;
  const [hovered, setHovered] = useState(false);

  const handleMouseEnterImage = useCallback(() => {
    setHovered(true);
  }, []);

  const handleMouseLeaveImage = useCallback(() => {
    setHovered(false);
  }, []);

  return (
    <Popup {...restProps} ref={ref} className={cn(styles.popup, className)} visible={visible}>
      <div className={styles.container}>
        <Cross className={styles.iconClose} view='default' size='xs' onClick={onClose} />

        <div className={styles.wrapperImage}>
          <BackgroundImage
            src={hovered && parameter.image ? parameter.image : parameter.preview}
            className={styles.img}
            onMouseEnter={handleMouseEnterImage}
            onMouseLeave={handleMouseLeaveImage}
          />
          {!hovered && parameter.image && <div className={styles.iconPlay} />}
        </div>

        <div className={styles.content}>
          <div className={styles.title}>{parameter.title}</div>
          <div
            className={styles.text}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: parameter.text }}
          />
        </div>
      </div>
    </Popup>
  );
});

MechanismPopup.displayName = 'MechanismPopup';

export default memo(MechanismPopup);
